/**
 * 참고(API): https://github.kakaocorp.com/kakaopage/api/blob/ad75ae912870621c23e6659954e59b4314020c8a/common/src/main/java/com/kakaopage/common/model/enums/BadgeType.java#L11
 * 참고(위키) : https://podotree.atlassian.net/wiki/spaces/PSD/pages/2793832719/BadgeType
 */
export enum BadgeTypeVo {
  /**
   * Next 기준 @deprecated
   */
  Hot = 'BT01',
  Up = 'BT02',
  New = 'BT03',
  /**
   * Next 기준 @deprecated
   */
  Only = 'BT04',
  /**
   * Next 기준 @deprecated
   */
  Free = 'BT05',
  /**
   * 에디터 추천
   * Next 기준 @deprecated
   */
  EditorRecomend = 'BT06',
  /**
   * 50% 할인
   * Next 기준 @deprecated
   */
  Discount50 = 'BT07',
  /**
   * 대여
   * Next 기준 @deprecated
   */
  Rental = 'BT08',
  /**
   * 휴재
   * Next 기준 @deprecated
   */
  Rest = 'BT09',
  /**
   * Next 기준 @deprecated
   */
  Top = 'BT10',
  /**
   * Next 기준 @deprecated
   */
  Event = 'BT11',
  /**
   * 선택안함
   * Next 기준 @deprecated
   */
  NonSelected = 'BT99',
}
